/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendTabularProductDto } from '../../models/backend-tabular-product-dto';
import { BackendTabularProductRequestDto } from '../../models/backend-tabular-product-request-dto';

export interface SalesTabularProductsCreate$FormData$Params {
  body?: BackendTabularProductRequestDto;
}

export function salesTabularProductsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params?: SalesTabularProductsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTabularProductDto>> {
  const rb = new RequestBuilder(rootUrl, salesTabularProductsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTabularProductDto>;
    }),
  );
}

salesTabularProductsCreate$FormData.PATH = '/api/sales/tabular-products/';
